import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { reducedMaxFileSize } from '../../../../../../../config';

export const getValidationSchema = (t: TFunction, noEmail: boolean) => {
    const prefix = 'iban-section.edit.validation.file-upload';
    return Yup.object().shape({
        file: Yup.array()
            .min(1, t(`${prefix}.required`))
            .max(1, t(`${prefix}.wrong-number-of-files`))
            .test('max-file-size', t(`${prefix}.wrong-size`), (files = []) =>
                files.every((file) => file?.size <= reducedMaxFileSize),
            ),
        email: noEmail
            ? Yup.string()
                  .trim()
                  .email(t(`${prefix}.email.mustBeEmail`))
                  .required(t(`${prefix}.email.required`))
            : Yup.string().notRequired(),
    });
};
